<template>
    <div class="mt-4 h-full">
      <div  class="text-expressgray w-screen overflow-x-scroll">
        <tabs  :options="{ useUrlFragment: false }" @changed="tabChanged" nav-item-class="nav-item" class="overflow-x-scroll">

          <tab name="Growth & Analytics" class="mt-5 h-full">
            <div class="h-full w-full">
                <admin_analytics></admin_analytics>
           </div>
          </tab>


          <tab name="Retailers (Nigeria)" class="mt-5 h-full">
            <div class="h-full">
              <retailertable v-if="activeTab === 'Retailers (Nigeria)'" country="Nigeria"/>

            </div>
          </tab>

          <tab name="Retailers (Ghana)" class="mt-5  h-full">
            <div class="h-full">
              <retailertable v-if="activeTab === 'Retailers (Ghana)'" country="Ghana"/>

            </div>
          </tab>
          <tab name="Retailers (Cote d'Ivoire)" class="mt-5  h-full">
            <div class="h-full">
              <retailertable v-if="activeTab === 'Retailers (Cote d\'Ivoire)'" country="CIV"/>

            </div>
          </tab>


          <tab name="Field Officers & Administrators" class="mt-5  h-full">
            <div class="h-full">
              <button
                type="button"
                class="w-full flex items-center justify-center space-x-2 p-4 mb-4 bg-white border-2 border-dashed border-gray-200 rounded-lg text-express font-medium hover:border-express hover:bg-express hover:bg-opacity-5 transition-colors"
                @click="showRDE"
              >
                <i class="fas fa-plus"></i>
                <span>Add New RDE & Administrator</span>
              </button>

              <div v-if="show_add_rde">
                <add_staff_model
                 @completeRDEAccount="completeRDEAccount"
                 @cancelRDEAccount="cancelRDEAccount"
                />
              </div>
              <rdetable/>
            </div>
          </tab>
          <tab name="Hotspot Customers" class="mt-5   h-full">
            <div class="h-full flex flex-col space-y-4">
              <userlist-table :rowRaws="customer_list"/>
              <pagination :total-pages="totalPages"
                          :total="total"
                          :per-page="perPage"
                          :current-page="currentPage"
                          :has-more-pages="hasMorePages"
                          @pagechanged="showMore">
              </pagination>
             </div>
          </tab>
        </tabs>
      </div>



    </div>
</template>

<script>
import retailerstable from "@/views/layouts/rde/rdeuicomponent/retailerstable";
import rdetable from "@/views/layouts/rde/rdeuicomponent/rdetable";
import add_staff_model from "@/components/uicomponents/models/add_staff_model";
// import usersTables from "@/components/uicomponents/tables/UsersTables";
import usersListTable from "@/components/uicomponents/tables/UsersListTable";
import { mapGetters } from 'vuex'
import analyticsContainer from "@/views/layouts/rde/rdeuicomponent/analyticsContainer";
export default {
  name: "RdeMain",
  created() {
    //
    this.$store.dispatch('customers/action_customer_list',{
      page_no: this.currentPage,
      perPage: this.perPage,
      toast:this.$toast,
      router:this.$router
    });


  },
  data(){
    return {
      show_add_rde: false,
      currentPage:1,
      perPage: 10,
      totalPages: 1,
      total:10,
      hasMorePages: null,
      activeTab: "Growth & Analytics"
    }
  },
  computed:{
    ...mapGetters({
      customer_list: 'customers/customer_list'
    }),
  },
  components:{
    "retailertable":retailerstable,
   "rdetable":rdetable,
    // "userstable":usersTables,
    "userlist-table":usersListTable,
    "admin_analytics":analyticsContainer,
    "add_staff_model": add_staff_model
  },
  methods:{
    tabChanged(selectedTab){
      this.activeTab = selectedTab.tab.name
    },
    showMore(data){
     this.currentPage = data
    },
    showRDE(){
      this.show_add_rde = !this.show_add_rde
    },
    cancelRDEAccount(){
      this.show_add_rde = false
    },
    completeRDEAccount(data){
      console.log("completedRDEAccount data",data)

      this.$store.dispatch('authentication/rde_register',{
        email: data[0].email,
        password:  data[0].password,
        phone: data[0].phone,
        name: data[0].name,
        country:  data[0].country,
        toast:this.$toast,
        router:this.$router
      });

      this.show_add_rde = false
    }
  }
}
</script>

